import playgroundApi from "../playgroundApi";
import {withDisplayErrorToUser} from "../error/error";
import {mySongsLibraryStore,} from "../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.store";
import {IMySongsLibraryResponse} from "../../client/models/mySongsLibrary/IMySongsLibraryResponse";
import {mySongsFiltersStore} from "../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

class MySongsLibraryPage {
  protected clearData(): void {
    mySongsLibraryStore.reset();
    mySongsFiltersStore.reset();
  }

  protected loadReduxStoresWithApiResponseData ({filters, userLibrary, library}: IMySongsLibraryResponse) {
    mySongsFiltersStore.fillWithData(filters);
    mySongsLibraryStore.fillWithData({fullLibrary: library, userLibrary});
  }
  public async load() {
    if (!mySongsLibraryStore.getIsRequestReadyToSend()){
      // not ready to load, return to exit
      return;
    }
    // notify is loading
    mySongsLibraryStore.setRequestStatus("loading");

    await withDisplayErrorToUser(async () => {
      try {
        // make request
        const songsResponse: IMySongsLibraryResponse = await playgroundApi.mySongsPageLibrary();
        // update store
        // notify loading complete
        mySongsLibraryStore.setRequestStatus("completed");
        this.loadReduxStoresWithApiResponseData(songsResponse);
      } catch (e) {
        // notify loading error
        mySongsLibraryStore.setRequestStatus("error");
        // throw error so error is output to user
        throw e;
      }
    });
  }

  public reset() {
    const isReadyToUnload = mySongsLibraryStore.getIsRequestCompleted() || mySongsLibraryStore.getIsRequestErrored();

    if (!isReadyToUnload) {
      // not able to unload, return to exit
      return;
    }

    this.clearData();
  }
}

export const mySongsLibrary = new MySongsLibraryPage();
export default mySongsLibrary;
